import { render } from "./bottoms.vue?vue&type=template&id=388b45c9&scoped=true"
import script from "./bottoms.vue?vue&type=script&lang=js"
export * from "./bottoms.vue?vue&type=script&lang=js"

import "./bottoms.vue?vue&type=style&index=0&id=388b45c9&scoped=true&lang=less"

import exportComponent from "D:\\work\\mvgx-carbon-space-admin-site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-388b45c9"]])

export default __exports__